import {
  ApiGeneralDataResponse,
  ApiResponse,
  GetTradeExtraInfoActivitiesResponse,
  GetTradeExtraInfoConfigurationResponse,
  GetTradeExtraInfoGeneralResponse,
  GetTradeExtraInfoOrdersResponse,
  GridCardData,
  OrderCardData,
  RawGetTradeExtraInfoOrdersResponse,
  RawOrder,
  RawTradeDetailsSocketData,
  RawTradeExtraInfoOrdersData,
  TradeDetailsSocketData,
  TradeExtraInfoActivity,
  TradeExtraInfoStats,
  TradeMetadata,
} from "@shared/types";
import { convertToObjectsArray } from "@shared/utils/arrays";

export const transformStats = (
  response: ApiResponse<ApiGeneralDataResponse<TradeExtraInfoStats>>
): TradeExtraInfoStats => response.data.data;

export const transformMetadata = (
  response: ApiResponse<ApiGeneralDataResponse<TradeMetadata>>
): TradeMetadata => response.data.data;

export const transformGeneral = (
  response: ApiResponse<GetTradeExtraInfoGeneralResponse>
): GetTradeExtraInfoGeneralResponse => response.data;

export const transformConfiguration = (
  response: ApiResponse<GetTradeExtraInfoConfigurationResponse>
): GetTradeExtraInfoConfigurationResponse => response.data;

const transformOrderCards = (
  rawOrders: RawOrder[],
  headers?: string[]
): OrderCardData[] =>
  rawOrders && headers ? convertToObjectsArray(rawOrders, headers) : [];

export const transformOrders = (
  response: ApiResponse<RawGetTradeExtraInfoOrdersResponse>
): GetTradeExtraInfoOrdersResponse => {
  const headers = response.data.headers;
  const rawData: RawTradeExtraInfoOrdersData = response.data.data;
  return {
    ...response.data,
    data: {
      ...rawData,
      entry_order_cards: transformOrderCards(
        rawData.entry_order_cards,
        headers
      ),
      take_profit_order_cards: transformOrderCards(
        rawData.take_profit_order_cards,
        headers
      ),
      stop_order_cards: transformOrderCards(rawData.stop_order_cards, headers),
    },
  } as GetTradeExtraInfoOrdersResponse;
};

export const transformActivities = (
  response: ApiResponse<GetTradeExtraInfoActivitiesResponse>
): TradeExtraInfoActivity[] =>
  convertToObjectsArray(response.data.data, response.data.headers);

export const transformGrids = (response: ApiResponse<any>): GridCardData[] =>
  convertToObjectsArray(response.data.data, response.data.headers);

export const transformSocketData = (
  raw: RawTradeDetailsSocketData
): TradeDetailsSocketData => {
  const result: TradeDetailsSocketData = {};

  if (raw.stats) {
    result.stats = raw.stats.data;
  }
  if (raw.metadata) {
    result.metadata = raw.metadata.data;
  }
  if (raw.general) {
    result.general = raw.general;
  }
  if (raw.orders) {
    result.orders = transformOrders({
      data: raw.orders,
    } as ApiResponse<RawGetTradeExtraInfoOrdersResponse>);
  }
  if (raw.activities) {
    result.activities = transformActivities({
      data: raw.activities,
    } as ApiResponse<GetTradeExtraInfoActivitiesResponse>);
  }
  if (raw.configuration) {
    result.configuration = raw.configuration;
  }
  if (raw.grids) {
    result.grids = convertToObjectsArray(raw.grids.data, raw.grids.headers);
  }

  return result;
};
